import React from 'react'

import CASE from '../../../constants/Case'

import { CenterText, Child, Slider, Container, Heading } from '../Home.styled'

import Carousel from '../../../components/Carousel/Carousel'
import Card from '../../../components/Card/Card'
import Button from '../../../components/Button/Button'
import BookingModal from '../../../components/BookingModal/BookingModal'

const CaseStudy = ({ innerref }) => {
  const [modalOpen, setModalOpen] = React.useState(false)
  return (
    <Container heightXL='600px' heightXS='500px'>
      <Child>
        <Heading ref={innerref}>
          Case Study
        </Heading>
      </Child>
      <Child>
        <CenterText>
          No two brands are alike.<br />
          Each poses its own unique set of problems.<br />
          Check out how we have tackled them over the years.
        </CenterText>
      </Child>
      <Slider>
        <Carousel maxVisibility={3} >
          {CASE.map((details, id) => (
            <Card key={id} details={details} />
          ))}
        </Carousel>
      </Slider>
      <Child>
        <Button mode='light' text='BOOK A CALL' clickEvent={() => setModalOpen(true)} />
        <BookingModal open={modalOpen} onClose={() => setModalOpen(false)} />
      </Child>
    </Container>
  )
}

export default CaseStudy
